import { render, staticRenderFns } from "./InsuredSelect.vue?vue&type=template&id=9d831142&"
import script from "./InsuredSelect.vue?vue&type=script&lang=js&"
export * from "./InsuredSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports